module.exports = __webpack_public_path__ + "img/photo-studio-art-direction.1e694a0f.gif";